import { render, staticRenderFns } from "./ManageViewComponent.vue?vue&type=template&id=47a52300&scoped=true"
import script from "./ManageViewComponent.vue?vue&type=script&lang=js"
export * from "./ManageViewComponent.vue?vue&type=script&lang=js"
import style0 from "./ManageViewComponent.vue?vue&type=style&index=0&id=47a52300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a52300",
  null
  
)

export default component.exports